import { atom, selector, useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil'
import { ICurrency } from '../types/types'
import { api } from '../utils/api'
import { useCallback } from 'react'

const fetchCurrencies = async (): Promise<ICurrency[]> => {
  const { data } = await api.get('/currencies')
  return data.currencies
}

export const currenciesState = atom<ICurrency[]>({
  key: 'currenciesState',
  default: selector({
    key: 'currenciesState/Default',
    get: async (): Promise<ICurrency[]> => fetchCurrencies(),
  }),
})

export const useAddCurrencies = (data) => {
  const set = useSetRecoilState(currenciesState)

  set(data)
}

export const useFetchCurrencies = () => {
  const set = useSetRecoilState(currenciesState)

  return useCallback(async () => {
    const { data } = await api.get('/currencies')

    if (data.currencies) {
      set(data.currencies)
    }
  }, [])
}

export const useAddCurrency = () => {
  const [currencies, setCurrencies] = useRecoilState(currenciesState)

  const addCurrency = (currency: ICurrency) => {
    setCurrencies([...currencies, currency])
  }

  return addCurrency
}

export const useRemoveCurrency = () => {
  const [currencies, setCurrencies] = useRecoilState(currenciesState)

  const removeCurrency = async (currencyId: string) => {
    const response = await api.delete(`/currency/${currencyId}`)

    if (response.status === 200) {
      setCurrencies(currencies.filter((currency) => currency.id !== currencyId))
    }
  }

  return removeCurrency
}

export const useCurrencies = (): ICurrency[] => {
  return useRecoilValue(currenciesState)
}